import request from '../utils/request.util'

export default {
  getList (params) {
    return request.get('devices/logs', { params })
  },
  getTotal (params) {
    return request.get('devices/logs/total', { params })
  }
}
